var _style, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTick(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 445 439.1",
    style: {
      enableBackground: "new 0 0 445 439.1"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{opacity:0.4;}\r\n\t.st1{fill:#BDD8B7;}\r\n\t.st2{fill:#FFFFFF;}\r\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1_00000077303705679772623820000015749436905703394714_"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    className: "st0"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 222.5,
    cy: 219.5,
    r: 177.2
  })), /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 222.5,
    cy: 219.5,
    r: 177.2
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M427.6,165.6c-9.5-36.3-28.6-69.5-55.2-96.1c-40.1-40.1-93.3-62.1-150-62.1s-109.9,22.1-150,62.1 C46,96.2,26.9,129.4,17.4,165.6l-7.2-1.9c9.8-37.5,29.6-71.9,57.1-99.4C108.7,22.8,163.9,0,222.5,0s113.8,22.8,155.2,64.3 c27.5,27.5,47.3,61.9,57.1,99.4L427.6,165.6L427.6,165.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M444.6,160.8c1.8,7.5-2.9,15.1-10.4,16.9c-7.5,1.8-15.1-2.9-16.9-10.4c-1.8-7.5,2.9-15.1,10.4-16.9 C435.3,148.6,442.8,153.3,444.6,160.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M0.4,160.8c-1.8,7.5,2.9,15.1,10.4,16.9c7.5,1.8,15.1-2.9,16.9-10.4c1.8-7.5-2.9-15.1-10.4-16.9 C9.7,148.6,2.2,153.3,0.4,160.8L0.4,160.8z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M222.5,439.1c-58.6,0-113.8-22.8-155.2-64.3c-26.9-26.9-46.4-60.4-56.5-97l7.2-2 c9.7,35.3,28.6,67.7,54.5,93.7c40.1,40.1,93.3,62.1,150,62.1s109.9-22.1,150-62.1c26-26,44.8-58.4,54.5-93.7l7.2,2 c-10,36.5-29.6,70.1-56.5,97C336.3,416.2,281.1,439.1,222.5,439.1L222.5,439.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M1,280.8c-1.9-7.5,2.7-15.1,10.2-17c7.5-1.9,15.1,2.7,17,10.2c1.9,7.5-2.7,15.1-10.2,17 C10.5,292.9,2.9,288.4,1,280.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M444,280.8c1.9-7.5-2.7-15.1-10.2-17c-7.5-1.9-15.1,2.7-17,10.2c-1.9,7.5,2.7,15.1,10.2,17 C434.5,292.9,442.1,288.4,444,280.8z"
  }))), /*#__PURE__*/React.createElement("polygon", {
    className: "st2",
    points: "297,136.8 190.2,243.5 148,201.3 118.6,230.6 190.2,302.3 326.4,166.1  "
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTick);
export default __webpack_public_path__ + "static/media/tick.f533134af7fa75c4ac3c352429bf6937.svg";
export { ForwardRef as ReactComponent };